module.exports = __webpack_public_path__ + "static/media/Note-Taker.7dc81d81.png";